export default {
    layout: {
        zh: '简体中文',
        tc: '繁體中文',
        en: 'English',
        kr: '한국어',
        jp: '日本語',
    },
    footer: {

    },
    menu: {
        home: '首页',
        mining: '矿机',
        wallet: '钱包',
        me: '我的',
        login: '登录'

    },
    home: {
        buy: '购买',
        dailyEarnings: '当日收益',
        topUp: '去充值',
        desc: '产品参数描述为隐性增长而生，为巨大成功而设计',
        popup: {
            buy: '立即购买',
            desc: '矿机收益，每天1%的收益(即每日3U)需每30天支付数据 盒(35U)才能获得，已经包含一个数据盒',
            totalAmount: '总金额',
            wallet: '资金钱包',
            revenue: '收益钱包',
            pls: '使用收益钱包支付',
            config: '配置钱包',
            most: '最多使用',
            confirmPurchase: '确认购买',
            plsDes: '请输入推荐人',
            confirm: '确认',
        }
    },
    mining: {
        title: '我的矿机列表',
        day: '当日总产出',
        activate: '持有待激活数据盒(个)',
        miningrig: '持有矿机(台)',
        output: '正在产出',
        dataCapsule: '数据盒',
        time: '购买时间',
        remaining: '剩余天数(天)',
        today: '今日产出',
        total: '总产出',
        expired: '即将过期',
        stop: '停产',
    },
    record: {
        title: '账户记录',
        empty: '暂无记录',
        wallet: '资金钱包',
        time: '日期',
        remark: '备注:见点释放',
        complimentary: '备注:赠送',
        static: '备注:静态收益',
    },

    wallet: {
        title: '我的钱包',
        record: '资金记录',
        static: '当日静态收益',
        dynamic: '当日动态奖励',
        topup: '充值',
        withdraw: '提现',
        totalRevenue: '矿机总收益',
        totalReward: '总奖励',
        funds: '资金钱包',
        fund1: '资金钱包',
        fund2: '收益钱包',
        fund3: '配置钱包',
    },
    withdraw: {
        title: '提现',
        revenue: '收益钱包',
        amount: '提现金额',
        confirm: '确认提现',
        rule: '提现规则',
        desc: '提现为每笔5U或5%,按价高计算',
        desc1: '最低提现额度为10U',
        list: '提现列表',
        success: '成功',
        time: '日期',
        error: '失败',
    },
    me: {
        recommend: '我的推荐人',
        subscription: '认购业绩',
        directReferral: '直推业绩',
        team: '我的团队(人)',
        performance: '团队业绩',
        serialNumber: '编号',
        level: '等级',
        individual: '个人业绩',
        time: '注册日期',
        home: '上一页',
        last: '下一页',
    },

};
